import { combineReducers } from 'redux'

import TestTemplate from './containers/TestTemplate';
import testTemplateReducer from './reducers/testTemplateReducer';
import goalReducer from './reducers/goalReducer';
import subjectReducer from './reducers/subjectReducer';
import contentSubTypeReducer from './reducers/contentSubTypeReducer';
import typeTestTemplateReducer from './reducers/typeTestTemplateReducer';


const reducers = combineReducers({
  testTemplateType: typeTestTemplateReducer,
  goal: goalReducer,
  subject: subjectReducer,
  contentSubType: contentSubTypeReducer,
  template: testTemplateReducer,
});

const components = { TestTemplate };

export { components, reducers };